import { Ruler } from "@nova/protobuf"
import { decideTakeSnapshotOfSecondaryLayer } from "features/map/control/module"
import { zoomToShowPoints } from "features/map/zoom/thunks"
import store from "integrations/redux/store"

export const zoomToRuler = (entity: Ruler) => {
    decideTakeSnapshotOfSecondaryLayer()
    store.dispatch(
        zoomToShowPoints({
            points: entity.coordinates.map(({ longitude, latitude }) => [longitude, latitude]),
        })
    )
}
